//set profanity data
export const SET_PROFANITY_WORDS = "SET_PROFANITY_WORDS";